import React, { useState } from 'react'
import { FaPaperPlane } from 'react-icons/fa'

const CommentForm = ({ onSubmit, loading }) => {
  const [newComment, setNewComment] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!newComment.trim()) return

    await onSubmit(newComment.trim())
    setNewComment('')
  }

  return (
    <form onSubmit={handleSubmit} className="flex gap-2">
      <input
        type="text"
        value={newComment}
        onChange={(e) => setNewComment(e.target.value)}
        placeholder="Add a comment..."
        className="flex-1 px-3 py-2 bg-white/10 border border-white/20 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm"
        maxLength={500}
      />
      <button
        type="submit"
        disabled={loading || !newComment.trim()}
        className="bg-purple-600 hover:bg-purple-700 disabled:bg-gray-600 text-white px-3 py-2 rounded-lg transition-colors flex items-center justify-center"
      >
        {loading ? (
          <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
        ) : (
          <FaPaperPlane className="text-sm" />
        )}
      </button>
    </form>
  )
}

export default CommentForm